// --- variable product label ---

var titleVase = document.querySelector('label[for="pa_vaso"]');
var titleRelated = document.querySelector('.fusion-woo-related-tb h4');

if (titleVase) {
    titleVase.innerHTML = 'Scegli tra i vasi per piante disponibili'
}

if (titleRelated) {
    titleRelated.innerHTML = "L'accessorio giusto per la cura delle piante"
}

// --- Button Scroll Class ---

var html = document.querySelector('html');
var floatingAddtocart = document.querySelector('.floating-addtocart');

if (floatingAddtocart) {

    document.addEventListener('scroll', function () {
        var scrolled = html.scrollTop;
        if (scrolled > 800) {
            floatingAddtocart.classList.add('is-visible');
        } else {
            floatingAddtocart.classList.remove('is-visible');
        }
    });

};


// --- Accordion.js initialization ---

var productAccordion = document.querySelector('#product-accordion')

if (productAccordion) {
    jQuery(document).ready(function($){
        $("#product-accordion").accordionjs({
           // activeIndex: false,
        });
    });
}

//

var addtocart = document.querySelector('.single_add_to_cart_button')

if (addtocart) {

    addtocart.addEventListener('click', function(e) {
        // e.preventDefault()
        console.log('add to cart clicked')
        dataLayer.push({'event': 'addToCart'})
    })
}